import { render, staticRenderFns } from "./alarms.vue?vue&type=template&id=53714dcc"
import script from "./alarms.vue?vue&type=script&lang=js"
export * from "./alarms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports